import styled from "styled-components";

export const ButtonAction = styled.button`
  margin-right: 5px;
  color: ${({ $isDelete }) => ($isDelete ? "#d6475f" : "#6ec1e4")};
  font-size: 1rem;
  border: 0px;
  background: transparent;
  width: max-content;
  height: 30px;
  width: 30px;

  &:hover {
    color: #fff;
    font-size: 1rem;
    background: ${({ $isDelete }) => ($isDelete ? "#d6475f" : "#6ec1e4")};
    border-radius: 30px;
  }
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;
